// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__1EL1m","LoaderBlue":"Spinner_LoaderBlue__2EyJO","LoaderRed":"Spinner_LoaderRed__2K4Nl","lds-dual-ring":"Spinner_lds-dual-ring__35LL8"};